module.exports = __webpack_public_path__ + "img/30c6d0d.png";